import styled from 'styled-components';

interface IHamburgerMenu {
  className?: string;
  height?: number;
  width?: number;
}

export const HamburgerMenu = ({ className, width, height }: IHamburgerMenu) => (
  <HamburgerMenu.Button aria-label="menu" type="button" className={className}>
    <HamburgerMenu.FlexWrapper height={height} width={width}>
      <HamburgerMenu.Slice />
      <HamburgerMenu.Slice />
      <HamburgerMenu.Slice />
    </HamburgerMenu.FlexWrapper>
  </HamburgerMenu.Button>
);

HamburgerMenu.Button = styled.button`
  padding-left: 0;
`;

HamburgerMenu.FlexWrapper = styled.div<{ height?: number; width?: number }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: ${({ height }) => (height ? `${height}px` : '11px')};
  width: ${({ width }) => (width ? `${width}px` : '14px')};

  > span {
    background-color: ${({ theme }) => theme.colors.black};
  }
`;

HamburgerMenu.Slice = styled.span`
  height: 1px;
`;
